export function setupPagination({ records, recordsPerPage, currentPage }: { records: number, recordsPerPage: number, currentPage: number }) {

    const pages = Math.ceil(records / recordsPerPage)
    const visiblePages = Math.min(5, pages)
    const visiblePagesPlusLimits = Math.min(pages, visiblePages + 2)

    currentPage = Math.max(1, Math.min(currentPage, pages))

    const range: number[] = (pages <= visiblePagesPlusLimits)
        ? [...Array(visiblePagesPlusLimits)].map((_, index) => index + 1)
        : (currentPage <= visiblePages)
            ? Array.prototype.concat(
                [...Array(visiblePages)].map((_, index) => index + 1),
                0,
                pages
            )
            : (currentPage >= (2 + pages - visiblePages))
                ? Array.prototype.concat(
                    1,
                    0,
                    [...Array(visiblePages)].map((_, index) => 1 + index + (pages - visiblePages))
                )
                : Array.prototype.concat(
                    1,
                    0,
                    [...Array(visiblePages)].map((_, index) => index + currentPage - ((visiblePages - 1) / 2)),
                    0,
                    pages
                )

    return { currentPage, range, pages }

}
